import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { listEvents } from '../api/events'
import { useTickerStore, type TickerAlert } from '../stores/ticker'
import { toAlertLevel } from '../lib/alert-level'

/**
 * 紧急告警滚动条数据源：MQTT 直写队列 ∪ 轮询 pending 事件兜底，按 eventId/key 去重。
 */
export function useTickerAlerts(): TickerAlert[] {
  const mqttAlerts = useTickerStore((s) => s.alerts)

  const { data } = useQuery({
    queryKey: ['events', 'list', { status: 'pending', source: 'ticker' }],
    queryFn: () => listEvents({ status: 'pending', page: 1, pageSize: 20 }),
    refetchInterval: 30_000,
    staleTime: 15_000,
  })

  return useMemo(() => {
    const merged = new Map<string, TickerAlert>()
    for (const alert of mqttAlerts) merged.set(alert.key, alert)
    for (const event of data?.items ?? []) {
      const key = `evt-${event.eventId}`
      if (merged.has(key)) continue
      merged.set(key, {
        key,
        eventId: event.eventId,
        title: `${event.name || event.eventId}`,
        level: toAlertLevel(event.alertLevel, event.severity),
        ts: event.originTime,
      })
    }
    return [...merged.values()].sort((a, b) => b.ts - a.ts).slice(0, 30)
  }, [mqttAlerts, data])
}
